import Reveal3 from '@/components/marketing3/Reveal3'
import { cn } from '@/lib/utils'

/**
 * ValueStrip3 — the light seam out of the dark hero. Five belief chips (value,
 * not mechanics — they replace v2's spec chips) followed by the live line.
 *
 * Every string is verbatim from the copy doc's §Value strip. Chips reveal on
 * scroll with a stagger (entrance-only, reduced-motion gated). The single
 * continuous animation here is the live dot's pulse.
 *
 * The sixth commercial chip was removed 2026-07-05 (founder direction — not yet
 * guaranteed; see docs/marketing/claims-register.md §6 commercial row and the copy
 * doc's §Value strip). Five chips is the intended final count.
 */

const container = 'mx-auto max-w-6xl px-4 sm:px-6'

const BELIEF_CHIPS = [
  'Every price explained',
  'Every change audited',
  'Guardrails you set',
  'Overrides always win',
  'Forecasts graded daily',
]

export default function ValueStrip3({ brand }: { brand: string }) {
  return (
    <section aria-label={`Why ${brand}`} className="border-b border-stone-200/70">
      <div className={cn(container, 'py-12 sm:py-14')}>
        <ul className="flex flex-wrap items-center justify-center gap-2.5 sm:gap-3">
          {BELIEF_CHIPS.map((chip, i) => (
            <Reveal3 as="li" key={chip} delay={i * 60}>
              <span className="mkt3-chip mkt3-label inline-flex items-center rounded-full px-3.5 py-2 tracking-[0.1em] text-slate-600">
                {chip}
              </span>
            </Reveal3>
          ))}
        </ul>

        <Reveal3 delay={380}>
          <p className="mt-8 flex items-center justify-center gap-2.5 text-center text-sm text-slate-600">
            <span
              aria-hidden="true"
              className="mkt3-live-dot inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-teal-500 shadow-[0_0_8px_rgba(13,148,136,0.7)]"
            />
            Running live on our own boutique hotels — it prices our rooms tonight.
          </p>
        </Reveal3>
      </div>
    </section>
  )
}
